import {
    FETCH_LOGIN_REQUEST,
    FETCH_LOGIN_SUCCESS,
    INTIALIZE,
    REMOVE_TOKEN,
} from "./type";

import axios from "axios";
import { API_ENDPOINT } from '../../AppConfig';
import { hideLoading } from 'react-redux-loading-bar';
import { showSnack } from 'react-redux-snackbar';

export function LoginRequest(data) {
    return (dispatch, getState) => {
        dispatch({ type: FETCH_LOGIN_REQUEST });
        let uri = `${API_ENDPOINT}/adminSignin`;
        axios.post(uri, data, {
            headers: {
                'Accept-Language': "ar"
            }
        })
            .then(response => {
                saveToLocalStorage('maktaptioken', JSON.stringify(response.data.token));
                console.log("token login", JSON.stringify(response.data.token))
                saveToLocalStorage('id', response.data.user.id);
                saveToLocalStorage('maktaptiType', JSON.stringify(response.data.user.type));
                saveToLocalStorage('maktaptirules', JSON.stringify(response.data.user.rules));
                dispatch({ type: FETCH_LOGIN_SUCCESS, payload: response.data });
                dispatch(hideLoading());
                console.log("userdatalogin", response.data.user.type)
            }).catch(error => {
                if (!error.response) {
                    dispatch(hideLoading());
                    dispatch(showSnack('myUniqueId', {
                        label: 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: ' تسجيل الدخول' }
                    }));
                } else if (error.response.status === 422 || error.response.status === 404 || error.response.status === 403) {
                    dispatch(hideLoading());
                    dispatch(showSnack('myUniqueId', {
                        label: 'البريد الالكترونى او كلمة المرور اونوع المستخدم غير صحيح',
                        timeout: 7000,
                        button: { label: ' تسجيل الدخول' }
                    }));
                }

                else if (error.response.status === 403) {
                    dispatch(hideLoading());
                }
            })
    }
}

export function IntializeToken(token, rule, type) {
    console.log("in action", token, "rules", rule, "Type", type)
    return (dispatch, getState) => {
        dispatch({ type: INTIALIZE ,Payload:{token:JSON.parse(token),rules:JSON.parse(rule),type:JSON.parse(type)}});
    }
}
// export function  IntializeToken (token){
//     return (dispatch, getState) => {
//         dispatch({ type: INTIALIZE ,tokenPayload:JSON.parse(token)});
//     }
// }
export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}
export function sendLogout() {
    console.log("logout")
    saveToLocalStorage('maktaptioken', '');
    // localStorage.removeItem("maktaptioken");
    return (dispatch, getState) => {
        dispatch({ type: REMOVE_TOKEN });
    }
}